export default "__VITE_ASSET__D5k902Eo__"